@if (control.errors && control.touched) {
  <div>
    <ul style="margin-left: 15px">
      @for (error of control.errors | keyvalue; track error) {
        <li style="color: red">
          {{ getErrorMessage(error.key, error.value) }}
        </li>
      }
    </ul>
  </div>
}
